import Vue from 'vue';

const state = {
  local: Vue.observable({
    isProcessing: false,
    // Distinct from `store.dashboard === null`: that means "not fetched yet",
    // this means "a fetch came back broken". The screen says different things
    // for each, which is the whole point.
    loadFailed: false,
    fetchedAt: null,
    topicId: '',
    cap: 1,
    requeueReason: '',
    // The reason that produced the currently-shown orphan preview, snapshotted
    // the moment the server refuses (needsConfirmation: true). confirmRequeue
    // must send this, never the live `requeueReason` -- the select can move
    // on while the preview is still showing, and a confirm has to bind to
    // what the operator actually saw, not to whatever it holds now. Cleared
    // whenever the preview itself resolves (success or replaced).
    previewedReason: null,
  }),
};

const template = {
  ticks: {
    header: [
      { title: 'vdo-migration.ticks.started-at', id: 'startedAt' },
      { title: 'vdo-migration.ticks.duration', id: 'durationMs' },
      { title: 'vdo-migration.ticks.outcome', id: 'outcome' },
      { title: 'vdo-migration.ticks.renewals', id: 'lockRenewals' },
      { title: 'vdo-migration.ticks.stopped', id: 'stopped' },
      { title: 'vdo-migration.ticks.pid', id: 'pid' },
    ],
  },
};

export default { state, template };
